import { UserRole } from 'enums';
import { User } from 'types';

// The user in this context is either the logged-in user OR the endUser if me.role is Backoffice
export function isIntegrationEnabled(user: Pick<User, 'organization' | 'role'> | null) {
  return !!user?.organization.emailIntegration?.type || user?.role === UserRole.CapitolaBroker;
}
